import Swiper, { Autoplay, Navigation } from 'swiper'; Swiper.use(Navigation); Swiper.use(Autoplay);

// Swipers to handle carousels -------------------------------------------------------------------- //

export function init() {

	const allProductSliders = document.querySelectorAll('.module-productslider .swiper-container');
	const productSlider = [];

	allProductSliders.forEach((el, i) => {

		productSlider[i] = new Swiper(el, {
			slidesPerView: 1.5,
			speed: 700,
			freeMode: true,
			navigation: {
				nextEl: '.module-productslider .slide-right',
				prevEl: '.module-productslider .slide-left'
			},
			breakpoints: {
				850: {
					slidesPerView: 3.5
				}
			}
		});

		productSlider[i].on('progress', () => {
			if (productSlider[i].isEnd && productSlider[i].isBeginning) {
				el.parentElement.parentElement.classList.remove('-rightfade', '-leftfade');
				el.parentElement.querySelector('.slide-right').classList.remove('-visible');
				el.parentElement.querySelector('.slide-left').classList.remove('-visible');
			} else if (productSlider[i].isEnd) {
				el.parentElement.parentElement.classList.remove('-rightfade');
				el.parentElement.parentElement.classList.add('-leftfade');
				el.parentElement.querySelector('.slide-right').classList.remove('-visible');
				el.parentElement.querySelector('.slide-left').classList.add('-visible');
			} else if (productSlider[i].isBeginning) {
				el.parentElement.parentElement.classList.remove('-leftfade');
				el.parentElement.parentElement.classList.add('-rightfade');
				el.parentElement.querySelector('.slide-left').classList.remove('-visible');
				el.parentElement.querySelector('.slide-right').classList.add('-visible');
			} else {
				el.parentElement.parentElement.classList.add('-leftfade', '-rightfade');
				el.parentElement.querySelector('.slide-right').classList.add('-visible');
				el.parentElement.querySelector('.slide-left').classList.add('-visible');
			}
		});

	});

	// --- //

	const allContentSliders = document.querySelectorAll('.module-contentslider .swiper-container');
	const contentSlider = [];

	allContentSliders.forEach((el, i) => {

		contentSlider[i] = new Swiper(el, {
			slidesPerView: 1.1,
			freeMode: true,
			speed: 700,
			spaceBetween: 10,
			navigation: {
				nextEl: '.module-contentslider .slide-right',
				prevEl: '.module-contentslider .slide-left'
			},
			breakpoints: {
				450: {
					slidesPerView: 1.5
				},
				850: {
					spaceBetween: 20
				},
				950: {
					slidesPerView: 2.5,
					spaceBetween: 20
				}
			}
		});

		contentSlider[i].on('progress', () => {
			if (contentSlider[i].isEnd && contentSlider[i].isBeginning) {
				el.parentElement.parentElement.classList.remove('-rightfade', '-leftfade');
				el.parentElement.querySelector('.slide-right').classList.remove('-visible');
				el.parentElement.querySelector('.slide-left').classList.remove('-visible');
			} else if (contentSlider[i].isEnd) {
				el.parentElement.parentElement.classList.remove('-rightfade');
				el.parentElement.parentElement.classList.add('-leftfade');
				el.parentElement.querySelector('.slide-right').classList.remove('-visible');
				el.parentElement.querySelector('.slide-left').classList.add('-visible');
			} else if (contentSlider[i].isBeginning) {
				el.parentElement.parentElement.classList.remove('-leftfade');
				el.parentElement.parentElement.classList.add('-rightfade');
				el.parentElement.querySelector('.slide-left').classList.remove('-visible');
				el.parentElement.querySelector('.slide-right').classList.add('-visible');
			} else {
				el.parentElement.parentElement.classList.add('-leftfade', '-rightfade');
				el.parentElement.querySelector('.slide-right').classList.add('-visible');
				el.parentElement.querySelector('.slide-left').classList.add('-visible');
			}
		});

	});

	// --- //

	const allImageGalleries = document.querySelectorAll('.module-imagegallery .swiper-container');
	const imageGallery = [];

	allImageGalleries.forEach((el, i) => {

		imageGallery[i] = new Swiper(el, {
			autoplay: {
				delay: 5000,
			},
			slidesPerView: 1.2,
			speed: 700,
			spaceBetween: 10,
			centeredSlides: true,
			loop: true,
			navigation: {
				nextEl: '.module-imagegallery .slide-right',
				prevEl: '.module-imagegallery .slide-left'
			},
			breakpoints: {
				650: {
					slidesPerView: 1.3,
					spaceBetween: 10
				},
				850: {
					spaceBetween: 20,
					slidesPerView: 1.6
				}
			},
		});

	});

	// --- //

	const allProductSwipers = document.querySelectorAll('.module-productlistswipe .swiper-container');
	const productSwiper = [];

	allProductSwipers.forEach((el, i) => {

		productSwiper[i] = new Swiper(el, {
			slidesPerView: 1.2,
			speed: 700,
			spaceBetween: 10,
			navigation: {
				nextEl: el.parentElement.querySelector('.slide-right'),
				prevEl: el.parentElement.querySelector('.slide-left')
			},
			breakpoints: {
				650: {
					slidesPerView: 1.5,
					spaceBetween: 10
				},
				850: {
					spaceBetween: 20,
					slidesPerView: 3.2
				}
			}
		});

		setInterval(() => {
			if (productSwiper[i].isEnd && productSwiper[i].isBeginning) {
				el.parentElement.parentElement.classList.remove('-rightfade', '-leftfade');
				el.parentElement.querySelector('.slide-right').classList.remove('-visible');
				el.parentElement.querySelector('.slide-left').classList.remove('-visible');
			} else if (productSwiper[i].isEnd) {
				el.parentElement.parentElement.classList.remove('-rightfade');
				el.parentElement.parentElement.classList.add('-leftfade');
				el.parentElement.querySelector('.slide-right').classList.remove('-visible');
				el.parentElement.querySelector('.slide-left').classList.add('-visible');
			} else if (productSwiper[i].isBeginning) {
				el.parentElement.parentElement.classList.remove('-leftfade');
				el.parentElement.parentElement.classList.add('-rightfade');
				el.parentElement.querySelector('.slide-left').classList.remove('-visible');
				el.parentElement.querySelector('.slide-right').classList.add('-visible');
			} else {
				el.parentElement.parentElement.classList.add('-leftfade', '-rightfade');
				el.parentElement.querySelector('.slide-right').classList.add('-visible');
				el.parentElement.querySelector('.slide-left').classList.add('-visible');
			}
		}, 500);

	});

	// --- //

	const allReviewSliders = document.querySelectorAll('.module-reviewslider .swiper-container');
	const reviewSlider = [];

	allReviewSliders.forEach((el, i) => {

		reviewSlider[i] = new Swiper(el, {
			slidesPerView: 1.1,
			freeMode: true,
			speed: 700,
			spaceBetween: 10,
			centerInsufficientSlides: true,
			navigation: {
				nextEl: '.module-reviewslider .slide-right',
				prevEl: '.module-reviewslider .slide-left'
			},
			breakpoints: {
				450: {
					slidesPerView: 1.5
				},
				850: {
					slidesPerView: 3.5,
					spaceBetween: 20
				},
				950: {
					slidesPerView: 4.5,
					spaceBetween: 20
				}
			}
		});

		setInterval(() => {
			if (reviewSlider[i].isEnd && reviewSlider[i].isBeginning) {
				el.parentElement.parentElement.classList.remove('-rightfade', '-leftfade');
				el.parentElement.querySelector('.slide-right').classList.remove('-visible');
				el.parentElement.querySelector('.slide-left').classList.remove('-visible');
			} else if (reviewSlider[i].isEnd) {
				el.parentElement.parentElement.classList.remove('-rightfade');
				el.parentElement.parentElement.classList.add('-leftfade');
				el.parentElement.querySelector('.slide-right').classList.remove('-visible');
				el.parentElement.querySelector('.slide-left').classList.add('-visible');
			} else if (reviewSlider[i].isBeginning) {
				el.parentElement.parentElement.classList.remove('-leftfade');
				el.parentElement.parentElement.classList.add('-rightfade');
				el.parentElement.querySelector('.slide-left').classList.remove('-visible');
				el.parentElement.querySelector('.slide-right').classList.add('-visible');
			} else {
				el.parentElement.parentElement.classList.add('-leftfade', '-rightfade');
				el.parentElement.querySelector('.slide-right').classList.add('-visible');
				el.parentElement.querySelector('.slide-left').classList.add('-visible');
			}
		}, 500);

	});

}
